import { seo, SeoData } from './seo';
import { uiSearch } from './results';
import { SearchResults } from './search.result.types';
import { fetchGraphql } from '@zoopla/fetch-graphql';

export default function search(path: string) {
    // TODO: think about how to write to redis
    return Promise.allSettled([seo(path), uiSearch(path)]).then(
        ([seoResult, searchResult]) => {
            const result: {
                errors?: Error[];
                data: { seo?: SeoData | null; searchResults?: SearchResults };
            } = { data: {} };
            const errors = [];

            if (seoResult.status === 'rejected') {
                errors.push(seoResult.reason);
            } else {
                result.data.seo = seoResult.value;
            }

            if (searchResult.status === 'rejected') {
                errors.push(searchResult.reason);
            } else {
                result.data.searchResults = searchResult.value;
            }

            if (errors.length > 0) {
                result.errors = errors;
            }

            // fire and forget
            // TODO: ingest from log drain and remove?
            fetchGraphql(
                `mutation logSearch($path: String!) { logSearch(url: $path) }`,
                {
                    path
                }
            ).catch(() => {
                // it's not critical this completed
            });

            return result;
        }
    );
}
